const Agridential = require('./agridential')
const HauGiang = require('./haugiang')
const MedicineBlockchain = require('./mbc')
const Vibi = require('./vibi')
const Vibi2 = require('./vibi2')

const NETWORK_CONFIG = {
    // Mainnet
    agd: Agridential,
    hg: HauGiang,
    vibi: Vibi,
    vibi2: Vibi2,

    // Testnet
    mbc: MedicineBlockchain
}

module.exports = { NETWORK_CONFIG }
